import { useState } from "react";
import { Abas, Aviso, PainelDaAba } from "../componentes/ui";
import { PainelDaCarteira } from "../componentes/sucesso/PainelDaCarteira";
import { PainelDeAlertas } from "../componentes/sucesso/PainelDeAlertas";
import { PainelDosPesos } from "../componentes/sucesso/PainelDosPesos";
import { podeNaSessao, useSessao } from "../nucleo/sessao";
import { useTitulo } from "../nucleo/titulo";

type Aba = "carteira" | "alertas" | "pesos";

const ABAS = [
  { chave: "carteira" as const, rotulo: "Carteira" },
  { chave: "alertas" as const, rotulo: "Quedas de faixa" },
  { chave: "pesos" as const, rotulo: "Pesos e faixas" },
];

/** Sucesso do cliente: a saúde de cada organização, a carteira de CS e os alertas de queda. */
export function SaudeDosClientes() {
  useTitulo("Saúde dos clientes");
  const sessao = useSessao();
  const [ativa, setAtiva] = useState<Aba>("carteira");

  if (!sessao.data) {
    return (
      <p className="lead" role="status">
        Verificando o seu acesso…
      </p>
    );
  }
  if (!podeNaSessao(sessao.data, "sucesso:ver")) {
    return (
      <Aviso tom="marca" data-testid="sucesso-sem-permissao">
        A saúde dos clientes é acompanhada pela equipe da GEOvendas.
      </Aviso>
    );
  }
  const podeGerenciar = podeNaSessao(sessao.data, "sucesso:gerenciar");

  return (
    <div data-testid="saude-dos-clientes">
      <h1 className="titulo-pagina">Saúde dos clientes</h1>
      <p className="lead mb-4">
        Uma nota de 0 a 100 por cliente, calculada todo dia com o que acontece de verdade: chamados,
        prazos, satisfação, contato e implantação. Use para saber com quem falar primeiro.
      </p>
      <Abas<Aba> rotulo="Saúde dos clientes" id="saude" itens={ABAS} ativa={ativa} aoSelecionar={setAtiva} className="mb-4" />
      <PainelDaAba id="saude" chave="carteira" ativa={ativa}>
        <PainelDaCarteira podeGerenciar={podeGerenciar} />
      </PainelDaAba>
      <PainelDaAba id="saude" chave="alertas" ativa={ativa}>
        <PainelDeAlertas />
      </PainelDaAba>
      <PainelDaAba id="saude" chave="pesos" ativa={ativa}>
        <PainelDosPesos podeGerenciar={podeGerenciar} />
      </PainelDaAba>
    </div>
  );
}
